module.exports = __webpack_public_path__ + "static/media/Sept26-F19.6be597b7.png";